import e from"styled-components";import{COLORS as i}from"../../constants/Theme.js";const t=e.div`
	position: 
	// if allowEvents is true, then position is relative, else position is absolute
		${e=>(null==e?void 0:e.allowEvents)?"relative":"absolute"};
	left: 0px;
	top: 0px;
	width: 100%;
	height: 100%;
	z-index: 2;
	cursor: ${e=>(null==e?void 0:e.disabled)?"not-allowed":"pointer"};
`,o=e.div`
	margin-top: 8px;
	margin-bottom: 8px;
`;e.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 6px 8px;
	background: ${i.surface.hovered};
	border: 1px solid ${i.stroke.primary};
	border-radius: 4px;
`;const r=e.div`
	width: 360px;
	height: 100%;
	padding: 8px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-radius: 4px;
	border: 1px solid ${i.stroke.primary};
	.chips-container {
		display: flex;
		gap: 8px;
		flex-wrap: wrap;
		align-items: center;
	}
`;export{r as ChipInputWrapper,o as OpenDropdownContainer,t as OverLapAbs};
